import { Monitor, Sun, Moon } from "lucide-react";

type Theme = "system" | "light" | "dark";

interface ThemeSelectorProps {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

export default function ThemeSelector({ theme, setTheme }: ThemeSelectorProps) {
  return (
    <div className="bg-surface border border-border rounded-lg p-4 space-y-3">
      <h3 className="text-sm font-medium text-foreground">Appearance</h3>
      <div className="flex rounded-lg border border-border overflow-hidden">
        {([
          { value: "system" as const, label: "System", Icon: Monitor },
          { value: "light" as const, label: "Light", Icon: Sun },
          { value: "dark" as const, label: "Dark", Icon: Moon },
        ]).map(({ value, label, Icon }) => (
          <button
            key={value}
            onClick={() => setTheme(value)}
            className={`flex-1 flex items-center justify-center gap-1.5 py-2 text-sm font-medium transition-colors ${
              theme === value
                ? "bg-primary text-primary-foreground"
                : "bg-surface text-muted-foreground hover:bg-surface-raised"
            }`}
          >
            <Icon className="w-4 h-4" />
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
